import { default as WJElement } from '../wje-element/element.js';
import ColorPicker from './color-picker.element.js';

export default ColorPicker;

WJElement.define('wje-color-picker', ColorPicker);
